import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import ReactDOM from "react-dom";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { useUniqueID } from "@xo-union/react-unique-id";
import Snackbar from "../Snackbar/index.js";
import { useSnackbarQueue, useSnackbarQueueContext } from "../SnackbarContext/index.js";
const DEFAULT_AUTO_DISMISS_MS = 20000;
const GLOBAL_CONTAINER_ID = 'Union__global-snackbar-container';
const ControlledSnackbar = /*#__PURE__*/React.forwardRef((props, ref) => {
  const [containerElement, setContainerElement] = React.useState();
  const fallbackQueue = useSnackbarQueue();
  const contextQueue = useSnackbarQueueContext();
  const queue = contextQueue || fallbackQueue;
  const id = useUniqueID();
  const {
    visible,
    onClose,
    ...snackbarProps
  } = props;
  React.useImperativeHandle(ref, () => {
    const api = {
      showAndDismiss: _ref => {
        let {
          data,
          dismissTimeout = DEFAULT_AUTO_DISMISS_MS
        } = _ref;
        queue.dismissAll(id);
        queue.push({
          id,
          data,
          dismissTimeout
        });
      },
      dismiss: () => {
        queue.dismissAll(id);
      },
      isVisible: () => queue.isVisible(id)
    };
    return api;
  }, [queue, id]);
  React.useEffect(() => {
    const container = document.getElementById(GLOBAL_CONTAINER_ID) || document.createElement('div');
    container.id = GLOBAL_CONTAINER_ID;
    document.body.appendChild(container);
    setContainerElement(container);
  }, []);
  const snackbar = /*#__PURE__*/React.createElement(Snackbar, _extends({
    visible: queue.isVisible(id),
    onClose: () => {
      queue.dismissAll(id);
      props.onClose();
    }
  }, snackbarProps), typeof snackbarProps.children === 'function' ? snackbarProps.children(queue.getData(id)) : queue.getData(id));
  if (snackbarProps.fixedToRelative) {
    return snackbar;
  }
  if (containerElement) {
    return /*#__PURE__*/ReactDOM.createPortal(snackbar, containerElement);
  }
  return null;
});
ControlledSnackbar.defaultProps = {
  fixedToRelative: false,
  onClose: noop
};
ControlledSnackbar.propTypes = {
  /**
   * Contents of snackbar
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * Whether or not to position the snackbar within a relative.
   * This use is discouraged except for a few scenarios like the sidebar. This
   * is only supported if the parent container is at the bottom of the viewport.
   */
  fixedToRelative: PropTypes.bool,
  /**
   * Called when the close button is clicked
   */
  onClose: PropTypes.func,
  /**
   * Should the snackbar be visible
   */
  visible: PropTypes.bool,
  /**
   * ID of the snackbar component
   */
  id: PropTypes.string
};
export default ControlledSnackbar;